import Cookies from 'js-cookie';
import { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

import { getCustomer } from 'redux/customer/actions';
import { list as listCustomerMetaData } from 'redux/customerMetaData/actions';
import { getForm } from 'redux/forms/actions';

import FormWrapper from './FormWrapper';

class App extends Component {
  componentDidMount() {
    const { props } = this;
    const { code } = this.props;
    props.getForm(code);
    props.listCustomerMetaData();
    if (Cookies.get('customerToken')) {
      props.getCustomer();
    }
  }

  render() {
    const { node, code } = this.props;
    return ReactDOM.createPortal(<FormWrapper code={code} node={node} />, node);
  }
}

export default connect(null, { getForm, listCustomerMetaData, getCustomer })(
  App
);
